import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import axios from "axios";

import faramoozSign from "../../../../image/faramoozSign.png";
import { myInvoiceApi } from "../../../../utility/api/apiList";

import {
  getCitiesKeyById,
  getCitiesKeyByState,
  getStateByID,
} from "../../../../libs/getConstants";
import scrollToTop from "../../../../libs/scrollToTop";

import LoadingComponent from "../../../../components/public/loading";
import ButtonComponent from "../../../../components/public/button";

import { FactorSection } from "./styledFactore";

export default function UserFinancialFactorContianer() {
  const [isLoading, setIsLoading] = useState(true);
  const [financialDetail, setFinancialDetail] = useState([]);
  const [isErrorInGetDetails, setIsErrorInGetDetails] = useState(false);

  const citiesKeyById = getCitiesKeyById();
  const citiesKeyByState = getCitiesKeyByState();

  let counter = 0;
  let totalPriceArray = [];
  let { id } = useParams();

  useEffect(() => {
    document.title = "فاکتور خرید-آزتو";
    scrollToTop();

    axios
      .get(`${myInvoiceApi}${id}/`)
      .then((response) => {
        var invoice = response.data;
        setFinancialDetail(invoice);
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      })
      .catch((error) => {
        setIsLoading(false);
        setIsErrorInGetDetails(true);
      });
  }, []);

  return (
    <>
      {isLoading ? (
        <LoadingComponent />
      ) : financialDetail.length == 0 ? (
        <div className="text-center pt-5">
          {isErrorInGetDetails ? (
            <>مشکلی پیش آمده. لطفا دوباره بعدا امتحان کنید.</>
          ) : (
            <>جزئیاتی وجود ندارد</>
          )}
        </div>
      ) : (
        <FactorSection className="container mt-5">
          <table className="table-factor">
            <tbody>
              <tr>
                <td className="first-td-table-factor-detail">
                  <div>فروشنده</div>
                </td>
                <td>
                  <div className="parrent-inf-first-table-factor">
                    <table>
                      <tbody>
                        <tr>
                          <td>نام شخص حقیقی / حقوقی : فراموز هنداسه</td>
                          <td>
                            شناسه ملی :
                            {financialDetail.invoice_config?.economic_number}
                          </td>
                          <td>
                            شماره ثبت :
                            {financialDetail.invoice_config?.registration_number}
                          </td>
                          <td>
                            شماره اقتصادی :
                            {financialDetail.invoice_config?.economic_number}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            نشانی شرکت : {financialDetail.invoice_config?.address}
                          </td>
                          <td>
                            کد‌پستی : {financialDetail.invoice_config?.postal_code}
                          </td>
                          <td>تلفن : {financialDetail.invoice_config?.tel}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
                <td className="parrent-inf-first-table-factor">
                  <div className="container-vital-inf-factor">
                    شناسه فاکتور : {financialDetail.id}
                  </div>
                </td>
              </tr>
              <tr>
                <td className="first-td-table-factor-detail">
                  <div> خریدار</div>
                </td>
                <td>
                  <div className="parrent-inf-first-table-factor">
                    {financialDetail.education == null ? (
                      //خرید شخصی
                      <table>
                        <tbody>
                          <tr>
                            <td>
                              نام شخص حقیقی / حقوقی :
                              {`${financialDetail.created_by_user.first_name} ${financialDetail.created_by_user.last_name}`}
                            </td>
                            <td>
                              شناسه ملی/ شماره ملی:
                              {financialDetail.created_by_user.usermeta.nid}
                            </td>
                            <td> کد اقتصادی: -</td>
                          </tr>
                          <tr>
                            <td> نشانی : تهران</td>
                            <td> استان : -</td>
                            <td> شهرستان : -</td>
                          </tr>
                          <tr>
                            <td>
                              تلفن :
                              {`${financialDetail.created_by_user.usermeta.phone}`}
                            </td>

                            <td>کد‌پستی : -</td>
                          </tr>
                        </tbody>
                      </table>
                    ) : (
                      //خرید سازمانی
                      <table>
                        <tbody>
                          <tr>
                            <td>
                              نام شخص حقیقی / حقوقی :
                              {financialDetail.education.legal ? (
                                <>{financialDetail.education.name}</>
                              ) : (
                                <>
                                  {`${financialDetail.created_by_user.first_name} ${financialDetail.created_by_user.last_name}`}
                                </>
                              )}
                            </td>

                            <td>
                              شناسه ملی/ شماره ملی:
                              {financialDetail.education.legal ? (
                                <>{financialDetail.education.national_id}</>
                              ) : (
                                <>{financialDetail.created_by_user.usermeta.nid}</>
                              )}
                            </td>
                            <td> کد اقتصادی: -</td>
                          </tr>
                          <tr>
                            <td>
                              نشانی :{getStateByID(financialDetail.education.state)}،
                              {
                                citiesKeyById.find(
                                  (item) =>
                                    item?.id == financialDetail.education.city
                                ).shahr
                              }
                            </td>
                            <td>
                              استان :{getStateByID(financialDetail.education.state)}
                            </td>
                            <td>
                              شهرستان :
                              {
                                citiesKeyByState.find(
                                  (item) =>
                                    item?.id == financialDetail.education.city
                                )?.shahr
                              }
                            </td>
                          </tr>
                          <tr>
                            <td>
                              تلفن :
                              {`${financialDetail.created_by_user.usermeta.phone}`}
                            </td>

                            <td>
                              کد‌پستی : {financialDetail.education.postal_code}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </td>
                <td className="parrent-inf-first-table-factor">
                  <div className="container-vital-inf-factor">
                    تاریخ :
                    <span className="inline-div">
                      {`${financialDetail.created_at.split(" ")[0]}`}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <table className="table-factor-information">
            {financialDetail.education == null ? (
              <>
                <thead>
                  <tr>
                    <td className="td-culomn-factor-table">ردیف</td>
                    <td>شناسه خدمات</td>
                    <td>شرح خدمات</td>
                    <td className="td-culomn-factor-table">تعداد</td>
                    <td>مبلغ واحد (تومان)</td>
                    <td> مبلغ کل (تومان)</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>{financialDetail?.invoicedetails_set[0]?.id}</td>
                    <td>
                      {financialDetail?.invoicedetails_set[0]?.sales_package?.name}
                    </td>
                    <td>1</td>
                    <td>
                      {financialDetail?.invoicedetails_set[0]?.sales_package?.price?.toLocaleString()}
                    </td>
                    <td>
                      {financialDetail?.invoicedetails_set[0]?.sales_package?.price?.toLocaleString()}
                    </td>
                  </tr>
                </tbody>
              </>
            ) : (
              <>
                <thead>
                  <tr>
                    <td className="td-culomn-factor-table">ردیف</td>
                    <td>شناسه خدمات</td>
                    <td>شرح خدمات</td>
                    <td className="td-culomn-factor-table">تعداد</td>
                    <td>مبلغ واحد </td>
                    <td> مبلغ کل</td>
                    {/* <td>  مبلغ تخفیف</td>
    <td>  مبلغ اضافات</td>
    <td> مبلغ کل پس از تخفیف و اضافات (تومان)</td>
    <td> جمع مالیات و عوارض</td>
    <td> خالص فاکتور</td> */}
                  </tr>
                </thead>
                <tbody>
                  {financialDetail.invoicedetails_set.map((item, index) => {
                    {
                      {
                        counter++;
                      }
                    }
                    {
                      {
                        totalPriceArray.push(item.count * item.unit_of_time.price);
                      }
                    }

                    return (
                      <tr key={index}>
                        <td>{counter}</td>
                        <td>{item.id}</td>
                        <td>{item.unit_of_time.name}</td>

                        <td>{item.count}</td>
                        <td>{item.unit_of_time.price.toLocaleString()}</td>
                        <td>
                          {(item.count * item.unit_of_time.price).toLocaleString()}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </>
            )}
          </table>
          <div className="my-2">
            <table className="container-total-price-inf-factor-detail">
              <thead>
                <tr>
                  <td>مبلغ کل (تومان)</td>
                  <td>مالیات بر ارزش افزوده (تومان)</td>
                  <td>مبلغ تخفیف (تومان)</td>
                  <td>مبلغ پرداختی (تومان)</td>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>
                    {financialDetail?.education == null ? (
                      <>
                        {financialDetail?.invoicedetails_set[0]?.sales_package?.price?.toLocaleString()}
                      </>
                    ) : (
                      <>
                        {totalPriceArray.reduce((a, b) => a + b, 0).toLocaleString()}
                      </>
                    )}
                  </td>
                  <td>{financialDetail?.total_tax.toLocaleString()}</td>
                  <td>{financialDetail?.total_discount.toLocaleString()}</td>
                  <td>{financialDetail?.total.toLocaleString()}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div>
            <table className="w-100">
              <tbody>
                <tr>
                  <td>
                    امضای فروشنده
                    <div className="faramooz-sign-image-container">
                      <img
                        className="faramooz-sign-image"
                        src={faramoozSign}
                        alt=""
                      />
                    </div>
                  </td>
                  <td>امضای خریدار</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="text-center mt-5">
            <ButtonComponent
              variant="outline-primary"
              className="not-print"
              onClick={() => window.print()}
            >
              پرینت
            </ButtonComponent>
          </div>
        </FactorSection>
      )}
    </>
  );
}
